<template>
  <el-container class="myContainer" style="width: 100%;height: 100%">
    <el-aside width="400px" class="myContainer" v-if="showCatalog">
      <el-card class="box-card" style="height: 100%;">
        <div style="font-size: 18px;line-height: 40px;position: relative;height: 100%;">
          <!--------------章节目录-------------->
          <div v-for="(item,index) in chapterList" :key="item.id" class="menu-box" @click="selectNode(item,index)"
               :style="this.currentNode.id === item.id?'background-color: #8eb8f5  ;':''">
            <span>第{{index+1}}章&nbsp;&nbsp;&nbsp;{{ item.name }}</span>
            <div class="task-status" >
              <span v-if="item.status === true">
                <img src="/tmp/courseDetail/ydh.png" alt=""/>
              </span>
              <span v-if="(item === this.chapterList[0] && !item.status) || (!item.status && this.chapterList[index-1].status)">
                <img src="/tmp/courseDetail/yd.png" alt=""/>
              </span>
              <span v-if="item !== this.chapterList[0] && !item.status && !this.chapterList[index-1].status">
                <img src="/tmp/courseDetail/ycw.png" alt=""/>
              </span>
            </div>

          </div>
        </div>
      </el-card>
    </el-aside>
    <el-main class="myContainer">
      <el-card class="box-card" style="height: 100%;">
        <div class="right-main">
          <div style="width: 1000px;padding: 0 0 20px 0">
            <div class="titleClass">
              <!-----------------章节目录------------------>
              <span style="font-size: 20px;">第{{nodeIndex}}章&nbsp;&nbsp;&nbsp;{{ currentChapter.name }}</span>
              <!-----------------------------------------点赞等操作按钮----------------------------------------->
              <div class="clickOperation">
                <!--------点赞-------->
                <el-tooltip content="点赞">
                  <div class="circle flex-h" @click="likeClick()" :class="isLike?'check':''">
                    <div class="img-box" :class="isLike?'img-box-check':''">
                      <img v-if="isLike" src="/tmp/courseDetail/goodBlack.png" alt=""/>
                      <img v-else src="/tmp/courseDetail/goodWhite.png" alt=""/>
                    </div>
                  </div>
                </el-tooltip>
                <p> {{ this.likeCnt }}</p>
                <!--------观看人数-------->
                <el-tooltip content="观看人数">
                  <div class="circle flex-h">
                    <div class="img-box"><img src="/tmp/courseDetail/gk.png" alt=""/>
                    </div>
                  </div>
                </el-tooltip>
                <p> {{ this.watchCnt }}</p>
                <!--------评论-------->
                <el-tooltip content="评论">
                  <div class="circle flex-h">
                    <div class="img-box"><img src="/tmp/courseDetail/comment.png" alt=""/>
                    </div>
                  </div>
                </el-tooltip>
                <p> {{ this.commentCnt }}</p>
                <el-button :disabled="isNotEnd" @click="openExercises"
                           style="margin-left: 20px;">课后习题
                </el-button>
                <el-button v-if="!showCatalog" @click="isShowCatalog" style="margin-left: 20px;">显示目录</el-button>
                <el-button v-if="showCatalog" @click="isShowCatalog" style="margin-left: 20px;">隐藏目录</el-button>
              </div>
            </div>
            <!-------------------------------------章节目录和介绍-------------------------------------------->
            <div style="padding: 5px 0 5px 0">
              <!-----------------章节介绍------------------>
              <span style="font-size: 15px">{{ currentChapter.introduction }}</span>
            </div>
            <!-------------------------------------------视频---------------------------------------------->
            <div class="myVideo">
              <video
                  id="myVideo"
                  :src="currentChapter.videoUrl"
                  :controls="controls"
                  oncontextmenu="return false"
                  style="width: 100%;height: 100%;object-fit:fill;" >
              </video>
            </div>
            <!----------评论主体----------->
            <div class="comment">
              <!----------评论输入框----------->
              <div class="input">
                <el-input v-model="comment" placeholder="请输入评论..." clearable type="textarea"
                          :autosize="{ minRows: 2, maxRows: 4 }"
                          style="margin-top: 10px;"></el-input>
                <el-button @click="addComment()" size="large" class="button">发布</el-button>
              </div>
              <!----------评论内容----------->
              <div style="">
                <div v-for="item in commentList.slice((currentPage - 1) * pageSize, currentPage * pageSize)"
                     :key="item.id" style="padding: 10px 0 10px 0;">
                  <div class="isDelete">
                    <span v-if="item.user_id === this.user_id " @click="deleteComment(item)" style="cursor: pointer;"><el-icon><Delete/></el-icon></span>
                    <span style="margin-left: 10px">{{ item.create_time }}</span>
                    <span style="margin-left: 10px;">{{ item.user_name }}:</span>
                    <span style="margin-left: 10px;">{{ item.operation_type }}</span>
                  </div>
                </div>
              </div>
              <!----------------分页----------------->
              <div class="pagination">
                <el-pagination background layout=" sizes, total, prev, pager, next,"
                               :page-sizes="[5,10,15,20]"
                               :current-page="currentPage"
                               v-model:page-size="pageSize"
                               :total="this.commentList.length"
                               @size-change="handleSizeChange"
                               @current-change="handleCurrentChange"
                               :small="false"/>
              </div>
            </div>
          </div>
        </div>
      </el-card>
    </el-main>
  </el-container>
  <!---------------------------------------------------课后习题---------------------------------------------->
  <el-dialog title="课后习题" v-model="showExercisesDialog" :close-on-click-modal="false" width="900px"
             style="--el-font-size-base: 12px;height: 500px">
    <div v-if="!exerciseData.finish">
      <el-card class="box-card" style="width: 100%;height: 400px;">
        <div style="width: 100%;height: 100%;padding:20px">
          <div v-for="(item,index) in exerciseData.courseQuestionList" :key="item.id" class="content">
            <div v-if="index === exercisesPage">
              <!-------------------- 多选题  -------------------->
              <div class="fill" v-if="item.question_type === 'multiple'">
                <div class="topic">
                  <span class="orderNumber">{{ index + 1 }}</span>
                  <span class="question_typeFill">多选题</span>
                </div>
                <!------------------题目----------------->
                <div class="tip" style="display: flex;align-items: center;">
                  <span>{{ item.topic }}</span>
                  <div class="circle flex-h" v-if="exerciseData.finish">
                    <div class="img-box">
                      <img v-if="item.isCorrect" src="/tmp/courseDetail/dh.png" alt=""/>
                      <img v-else src="/tmp/courseDetail/xh.png" alt=""/>
                    </div>
                  </div>
                </div>
                <el-checkbox-group v-model="item.my_answer" class="choice" size="large">
                  <el-checkbox v-if="item.option_a " :label="'option_a'" size="large">A. {{ item.option_a }}
                  </el-checkbox>
                  <el-checkbox v-if="item.option_b " :label="'option_b'" size="large">B. {{ item.option_b }}
                  </el-checkbox>
                  <el-checkbox v-if="item.option_c " :label="'option_c'" size="large">C. {{ item.option_c }}
                  </el-checkbox>
                  <el-checkbox v-if="item.option_d " :label="'option_d'" size="large">D. {{ item.option_d }}
                  </el-checkbox>
                  <el-checkbox v-if="item.option_e" :label="'option_e'" size="large">E. {{ item.option_e }}
                  </el-checkbox>
                  <el-checkbox v-if="item.option_f" :label="'option_f'" size="large">F. {{ item.option_f }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
              <!-------------------- 单选题  -------------------->
              <div class="single" v-if="item.question_type === 'single'">
                <div class="topic">
                  <span class="orderNumber">{{ index + 1 }}</span>
                  <span class="question_typeSingle">单选题</span>
                </div>
                <!------------------题目----------------->
                <div class="tip" style="display: flex;align-items: center;">
                  <span>{{ item.topic }}</span>
                  <div class="circle flex-h" v-if="exerciseData.finish">
                    <div class="img-box">
                      <img v-if="item.isCorrect" src="/tmp/courseDetail/dh.png" alt=""/>
                      <img v-else src="/tmp/courseDetail/xh.png" alt=""/>
                    </div>
                  </div>
                </div>
                <el-radio-group v-model="item.my_answer" class="choice" size="large">
                  <el-radio v-if="item.option_a " :label="'option_a'" size="large">A. {{ item.option_a }}</el-radio>
                  <el-radio v-if="item.option_b " :label="'option_b'" size="large">B. {{ item.option_b }}</el-radio>
                  <el-radio v-if="item.option_c " :label="'option_c'" size="large">C. {{ item.option_c }}</el-radio>
                  <el-radio v-if="item.option_d " :label="'option_d'" size="large">D. {{ item.option_d }}</el-radio>
                  <el-radio v-if="item.option_e " :label="'option_e'" size="large">E. {{ item.option_e }}</el-radio>
                  <el-radio v-if="item.option_f " :label="'option_f'" size="large">F. {{ item.option_f }}</el-radio>
                </el-radio-group>
              </div>
              <!-------------------- 判断题  -------------------->
              <div class="judge" v-if="item.question_type === 'judge'">
                <div class="topic">
                  <span class="orderNumber">{{ index + 1 }}</span>
                  <span class="question_typeJudge">判断题</span>
                </div>
                <!------------------题目----------------->
                <div class="tip" style="display: flex;align-items: center;">
                  <span>{{ item.topic }}</span>
                  <div class="circle flex-h" v-if="exerciseData.finish">
                    <div class="img-box">
                      <img v-if="item.isCorrect" src="/tmp/courseDetail/dh.png" alt=""/>
                      <img v-else src="/tmp/courseDetail/xh.png" alt=""/>
                    </div>
                  </div>
                </div>
                <el-radio-group v-model="item.my_answer" class="choice" size="large">
                  <el-radio :label="'true'" size="large">是</el-radio>
                  <el-radio :label="'false'" size="large">否</el-radio>
                </el-radio-group>
              </div>
              <!-------------------- 上一题 下一题 提交  -------------------->
              <div class="operation">
                <el-button type="primary" @click="previous()" v-if="index !== 0">上一题</el-button>
                <el-button type="primary" @click="toNext()"
                           v-if="index !== exerciseData.courseQuestionList.length-1 && item.my_answer">下一题
                </el-button>
                <el-button type="primary" @click="calculateScore()"
                           v-if="index === exerciseData.courseQuestionList.length-1 && item.my_answer">提交
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <!---------------  是否及格  ---------------->
    <div class="bottom" v-if="exerciseData.finish">
      <div v-if="isPass" style="">
        <img style="width: 75%;margin-left: 80px" src="/tmp/courseDetail/Pass.png" alt=""/>
        <span style="font-size: 40px;margin: 155px">继续学习下一章</span>
      </div>
      <div v-else style="margin-top: 25px">
        <img style="width: 100%;" src="/tmp/courseDetail/Fail.png" alt=""/>
        <span style="font-size: 40px;margin: 155px">请重新观看视频</span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {Delete} from "@element-plus/icons-vue";

export default {
  name: "CourseDetail",
  components: {Delete},
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },

  data() {
    return {
      showCatalog:true,
      currentPage: 1,
      pageSize: 5,
      currentNode: {},//当前鼠标所选择的节点
      nodeIndex:1,//当前选择节点的下标
      user_id: '',
      showExercisesDialog: false,
      isLike: false,
      likeCnt: 0,
      watchCnt: 0,
      commentCnt: 0,
      commentList: [],
      showCommentInput: false,
      comment: '',
      chapterList: [],
      currentChapter: {},//当前章节
      beforeChapter: {},//前一章节
      exerciseData: {},
      resultList: [],//课后习题完成情况的集合

      isNotEnd: true,//是否看完视频,看完为false

      isPass: false,//是否合格

      viewDuration: 0,
      timer: {}, // 定时器
      pauseTimer: {},// 暂停定时器
      controls: true,//是否显示控件
      control: false,//控件控制
      videoData: {},//视频基础数据
      exercisesPage: 0,// 当前页
    }
  },

  mounted() {
    this.getChapterData();
    this.getUserId();
  },

  methods: {

    //获取当前人员id
    getUserId() {
      this.user_id = this.$store.state.core.currentUser.id
    },

    //分页数据
    handleSizeChange(val) {
      this.pageSize = val
    },

    handleCurrentChange(val) {
      this.currentPage = val
    },

    //查询课程章节数据
    async getChapterData() {
      //查询数据
      // if (this.componentParam === 'my_course_study') {
      //   // eslint-disable-next-line vue/no-mutating-props
      //   this.parentData.isMyStudy = true
      // }
      let params = this.parentData
      let chapterList = await this.$http('ihtCourseService.getChapter', params)
      console.log("chapterList-=", chapterList)
      if (!chapterList) {
        return this.$message.error("获取课程失败")
      }
      this.chapterList = chapterList;

      //默认显示第一个章节的表单内容
      if (this.chapterList.length > 0) {
        this.selectNode(this.chapterList[0], 0);
        this.isNotEnd = true;
      }
    },

    //选择章节节点
    selectNode(currentRow, index) {
      // if (this.componentParam !== 'my_course_study') {
      //   this.currentNode = currentRow;
      //   this.getChapterDetail();
      // } else {
        if (currentRow === this.chapterList[0]){
          this.currentNode = currentRow;
          this.getChapterDetail();
          this.nodeIndex = 1;
        }else {
          if (this.chapterList[index - 1].status || this.chapterList[index].status ) {
            this.currentNode = currentRow;
            this.getChapterDetail();
            this.nodeIndex = index + 1;
          } else {
            this.$message.error("请先学习前一章")
          }
        }
      // }
    },

    //根据选择的获取章节详情数据
    async getChapterDetail() {
      this.currentChapter = await this.$http('ihtCourseService.getChapterDetail', this.currentNode)
      console.log("this.currentChapter-=",this.currentChapter)
      this.isLike = false
      //获取学习日志
      let params = {
        course_id: this.parentData.course_id,
        chapter_id: this.currentNode.id,
      }
      let videoOut = await this.$http('ihtStudyTaskService.getVideoOut',params);
      this.isNotEnd = !videoOut;

      this.playVideo();
      this.viewMonitor();
      await this.getLikeCnt();
      await this.getWatchCnt();
      await this.getComment();
    },

    //视频播放
    playVideo() {
      let that = this;
      //视频
      let myVideo = document.getElementById("myVideo");
      this.myVideo = myVideo;
      myVideo['disablePictureInPicture'] = true; // disablePictureInPicture的属性改为true 禁用画中画
      myVideo['controlsList'] = 'noplaybackrate  nodownload'; // 隐藏下载按钮 倍速按钮

      let time1;
      let t1 = 0;

      //观看时长
      function view() {
        t1 += 0.25;
        that.viewDuration = t1;
        console.log('view-' + t1);
      }

      // 禁止快进
      let sym;
      // setInterval(function () {
      //   let time = myVideo.currentTime
      //   if (time - sym > 1) {
      //     this.myVideo.pause();
      //     myVideo.currentTime = sym
      //   }
      //   sym = myVideo.currentTime
      // }, 500);

      //视频的总长度
      myVideo.addEventListener('loadedmetadata', () => { //加载数据
        this.totalDuration = myVideo.duration;
        console.log(this.totalDuration);
      });

      //播放
      myVideo.addEventListener('play', () => { //播放
        console.log("开始播放");
        // this.viewMonitor();
      });
      //暂停
      myVideo.addEventListener('pause', () => { //暂停
        console.log("暂停");
        window.clearInterval(time1);
        countTime();
      });
      //结束
      myVideo.addEventListener('ended', async () => { //结束
        console.log("播放结束");
        window.clearInterval(time1);
        countTime();   //向后台发数据
        this.isNotEnd = false;
        let course_id = '';
        if (this.componentParam === 'my_course_study') {
          course_id = this.parentData.course_id
        }else {
          course_id = this.parentData.id
        }
        let params = {
          course_id: course_id,
          chapter_id: this.currentNode.id,
        }
        await this.$http('ihtStudyTaskService.addStudyLog', params)
        this.$message.success("视频已看完，请完成课后习题")
        t1 = 0;
      }, false)
      //被主动暂停或网络暂停缓冲后重新播放会触发该事件
      //开始播放视频时，设置一个定时器，每250毫秒调用一次aa(),观看时长加2.5秒，
      //定时器需要放在playing事件中，否则无法实现网络缓冲后继续计时的功能
      myVideo.addEventListener("playing", () => {
        console.log("播放中");
        time1 = setInterval(() => {
          view();
          // this.getrViewDuration(t1)
        }, 250)
      }, false)
      //当因网络原因导致暂停时会触发该事件
      myVideo.addEventListener("waiting", () => {
        console.log('加载');
        window.clearInterval(time1);
        countTime();   //向后台发数据
      }, false)

      //计算观看时长向后台发数据
      async function countTime() {
        console.log("viewDuration", that.viewDuration)
        // let params = {viewDuration: that.viewDuration}
        // await this.$http('', params)
      }

      //直接关闭页面，并向后台发送数据
      if (window.addEventListener) {
        window.addEventListener("beforeunload", countTime, false);
      } else {
        window.attachEvent("onbeforeunload", countTime);
      }
    },

    //监控禁止切屏
    viewMonitor() {
      document.body.onblur = () => {
        if (this.myVideo.currentTime < this.totalDuration) {
          this.myVideo.pause();
        }
      }
    },

    //是否显示目录
    isShowCatalog(){
      this.showCatalog = !this.showCatalog;
    },

    //点赞事件
    async likeClick() {
      if (!this.isLike){
        let course_id = '';
        if (this.componentParam === 'my_course_study') {
          course_id = this.parentData.course_id
        }else {
          course_id = this.parentData.id
        }

        let params = {
          video_id: this.currentChapter.video_id,
          operation_type: 'like',
          is_comment: false,
          chapter_id: this.currentNode.id,
          course_id: course_id
        }
        await this.$http('ihtStudyTaskService.addClickRecord', params)
        this.getLikeCnt();
        this.isLike = !this.isLike
      }

    },

    //添加评论
    async addComment() {
      if (!this.comment) {
        return this.$message.error("请输入评论内容");
      }

      let course_id = '';
      if (this.componentParam === 'my_course_study') {
        course_id = this.parentData.course_id
      }else {
        course_id = this.parentData.id
      }

      let params = {
        video_id: this.currentChapter.video_id,
        operation_type: this.comment,
        is_comment: true,
        chapter_id: this.currentNode.id,
        course_id: course_id
      }
      await this.$http('ihtStudyTaskService.addClickRecord', params)
      this.comment = '';
      this.getComment();
    },

    //删除评论
    async deleteComment(item) {
      await this.$http('ihtStudyTaskService.deleteComment', item)
      await this.getComment();
    },

    //获取点赞数量
    async getLikeCnt() {
      let params = {video_id: this.currentChapter.video_id, operation_type: 'like',chapter_id: this.currentNode.id}
      let cntData = await this.$http('ihtStudyTaskService.getClickRecordCnt', params)
      if (cntData.cnt === 1) {
        this.isLike = true
      }
      this.likeCnt = cntData.sum;
    },

    //获取获取观看的数量
    async getWatchCnt() {
      let params = {chapter_id:this.currentNode.id}
      this.watchCnt = await this.$http('ihtStudyTaskService.getWatchCnt', params)
    },

    //获取所有评论
    async getComment() {
      let params = {video_id: this.currentChapter.video_id, is_comment: true,chapter_id: this.currentNode.id}
      let commentList = await this.$http('ihtStudyTaskService.getComment', params)
      this.commentList = commentList;
      this.commentCnt = commentList.length;
    },

    //获取课后习题
    async getExam() {
      this.currentChapter.courseQuestionList.forEach(exercises=>{
        delete exercises.my_answer
      })
      this.exerciseData.courseQuestionList = this.currentChapter.courseQuestionList
    },

    //打开课后习题
    async openExercises() {
      this.showExercisesDialog = true
      this.exerciseData.finish = false
      await this.getExam();
      this.exercisesPage = 0;
    },

    //下一题
    toNext() {
      this.exercisesPage++;
    },

    //上一题
    previous() {
      this.exercisesPage--;
    },

    //计算分数
    async calculateScore() {
      this.resultList = await this.$http('ihtCourseQuestionService.getAnswers', this.exerciseData);
      let isCorrectCnt = 0;
      this.resultList.forEach(result => {
        if (result.isCorrect) {
          isCorrectCnt += 1;
        }
      });
      this.exerciseData.courseQuestionList = this.resultList
      //是否合格
      if (!this.currentChapter.pass_question_cnt){
        this.currentChapter.pass_question_cnt = this.resultList.length
      }
      this.isPass = isCorrectCnt >= this.currentChapter.pass_question_cnt;
      this.exerciseData.isPass = this.isPass;
      //是否完成
      this.exerciseData.finish = true;

      this.exerciseData.chapter_id = this.currentNode.id
      await this.addCourseTestRecord();
      await this.taskOver();
    },

    //答题记录存入数据库
    async addCourseTestRecord(){
      console.log("this.exerciseData", this.exerciseData)
      await this.$http('ihtCourseQuestionService.addCourseTestRecord', this.exerciseData)
    },

    // 当视频和答题都完成时修改任务状态
    async taskOver(){
      let course_id = '';
      if (this.componentParam === 'my_course_study') {
        course_id = this.parentData.course_id
      }else {
        course_id = this.parentData.id
      }
      let params = {
        course_id: course_id,
        chapter_id: this.currentNode.id,
      }
      if (this.isPass) {
        await this.$http('ihtStudyTaskService.updateStudyLog', params)
        await this.getChapterData();
      }else {
        this.isNotEnd = true;
        await this.$http('ihtStudyTaskService.deleteStudyLog', params)
      }
    },

  },

}
</script>

<style scoped>

/*右边最外div样式*/
.right-main{
  height: 100%;
  padding: 0 0 20px 0;
  display: flex;
  justify-content: center;
  /*align-items: center;*/
}

/*任务状态样式*/
.task-status{
  position: absolute;
  right: 5px;
  top: 3px;
  width: 20px;
  height: 20px
}
.task-status img{
  width: 100%;
  height: 100%;
}

/*目录样式*/
.menu-box {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: relative;
  align-items: center;
  display: flex;
  padding: 0 0 0 10px;
  cursor: pointer;
}

/*鼠标选择的样式*/
.menu-box:hover {
  background-color: whitesmoke;
}

/*title样式*/
.titleClass{
  display: flex;
  align-items: center;
  position: relative;
  padding: 0 0 5px 0;
  border-bottom: 1px solid #e0dddd;
}

/*点赞等一系列操作的样式*/
.clickOperation {
  display: flex;
  align-items: center;
  font-size: 22px;
  position: absolute;
  right: 0;
}

.clickOperation p{
  margin: 2px 5px 0 5px;
}

  /*视频样式*/
.myVideo {
  padding:0;
  border: 1px solid lightgrey;
  height:600px;
}

/*评论区样式*/
.comment {
  background-color: #f3f0f0;
  margin-top: 5px;
  padding-bottom: 10px;
}

/*输入框样式*/
.input {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 0 5px 8px 5px;
}

.input .button {
  font-size: 15px;
  margin-left: 20px;
  --el-button-size: 50px;
  margin-top: 10px;
}

/*评论内容样式*/
.isDelete {
  margin: 0 0 4px 20px;
  font-size: 15px;
  border-bottom: 1px solid #e0dddd;
}

/*分页样式*/
.pagination{
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;
  padding: 0 5px 5px 0;
}

.myContainer {
  padding: 5px;
}

:deep(.el-card is-always-shadow) {
  height: 800px;
}

:deep(.el-card__body) {
  height: 100%;
  overflow: auto;
  padding: 15px 10px;
}

:deep(.el-checkbox.el-checkbox--large) {
  width: 100%;
}

:deep(.el-radio.el-radio--large) {
  width: 100%;
}

.content .el-radio-group el-radio {
  margin-left: 10px;
}

/*试题样式*/
.operation {
  padding: 30px;
}

.content .topic {
  display: inline-flex;
  align-items: center;
}

.topic .orderNumber {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 30px;
  background-color: rgb(39, 118, 223);
  color: #fff;
  border-radius: 4px;
  margin-right: 4px;
  font-size: 35px;
}

.topic .question_typeSingle {
  padding: 0 5px 0 5px;
  color: #409eff;
  background-color: #d9ecff;
  font-size: 22px;
}

.topic .question_typeFill {
  padding: 0 5px 0 5px;
  color: #e6a23c;
  background-color: #faecd8;
  font-size: 22px;
}

.topic .question_typeJudge {
  padding: 0 5px 0 5px;
  color: #67c23a;
  background-color: #f0f9eb;
  font-size: 22px;
}

.choice {
  margin-left: 30px;
}

.tip span {
  margin: 5px;
  font-size: 20px;
  text-align: left;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.right .title p {
  display: flex;
  margin-top: 0;
  background-color: #fff;
  height: 50px;
  line-height: 50px;
  margin-left: 10px;
  font-size: 20px;
}

.right .title span {
  font-size: 20px;
}

.select el-select {
  color: #0a84ff;
}

.bottom {
  padding: 30px;
  margin: 20px 100px 20px 100px;
  font-size: 20px;
  border: 1px solid lightgrey;
}

.answer .top .index li {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.right .topic li {
  display: flex;
  align-items: center;
  padding: 0 0 0 5px;
}

/*点赞样式*/
.circle {
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 0 0 0 rgba(223, 46, 58, 0.5);
}

.circle .img-box {
  width: 24px;
  height: 24px;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  /*-khtml-user-select: none;*/
  user-select: none;
  /*// 防止快速点击图片被选中，可不加，为提高体验，博主加上了这几行代码。*/
}

.circle .img-box img {
  width: 100%;
  height: 100%;
}

.check {
  -webkit-transition: box-shadow 0.5s;
  -moz-transition: box-shadow 0.5s;
  -o-transition: box-shadow 0.5s;
  transition: box-shadow 0.5s;
  box-shadow: 0 0 0 1em rgba(226, 32, 44, 0);
}

.img-box-check {
  animation: anm 0.5s;
  -moz-animation: anm 0.5s;
  -webkit-animation: anm 0.5s;
  -o-animation: anm 0.5s;
}

@keyframes anm {
  0% {
    transform: scale(0);
    -webkit-transform: scale(0);
    -moz-transform: scale(0);
  }
  50% {
    transform: scale(1.3);
    -webkit-transform: scale(1.3);
    -moz-transform: scale(1.3);
  }
  100% {
    transform: scale(1);
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
  }
}



</style>